import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { Icon } from '@livable/saas-react-components';
import { TextField } from '@mui/material';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import DatePicker from 'react-datepicker';
import useStyles from './styles';
export default function RangeDatePicker(_ref) {
  let disabled = _ref.disabled,
    format = _ref.format,
    fromDate = _ref.fromDate,
    handleDateChange = _ref.handleDateChange,
    label = _ref.label,
    minDate = _ref.minDate,
    maxDate = _ref.maxDate,
    noValidate = _ref.noValidate,
    popperPlacement = _ref.popperPlacement,
    reinitialize = _ref.reinitialize,
    setIsReinitialize = _ref.setIsReinitialize,
    showPreviousMonths = _ref.showPreviousMonths,
    toDate = _ref.toDate,
    _ref$monthsShown = _ref.monthsShown,
    monthsShown = _ref$monthsShown === void 0 ? 2 : _ref$monthsShown;
  const classes = useStyles();
  const _useState = useState(fromDate ? moment(fromDate).toDate() : null),
    _useState2 = _slicedToArray(_useState, 2),
    startDate = _useState2[0],
    setStartDate = _useState2[1];
  const _useState3 = useState(toDate ? moment(toDate).toDate() : null),
    _useState4 = _slicedToArray(_useState3, 2),
    endDate = _useState4[0],
    setEndDate = _useState4[1];
  const _useState5 = useState(null),
    _useState6 = _slicedToArray(_useState5, 2),
    error = _useState6[0],
    setError = _useState6[1];
  useEffect(() => {
    if (reinitialize) {
      if (fromDate) setStartDate(moment(fromDate).toDate());else if (fromDate === '' || fromDate === 'Invalid date') setStartDate(null);
      if (toDate) setEndDate(moment(toDate).toDate());else if (toDate === '' || toDate === 'Invalid date') setEndDate(null);
      setIsReinitialize(false);
      setError(null);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reinitialize]);
  const onChange = (dates, e, isExternalCall) => {
    const _dates = _slicedToArray(dates, 2),
      start = _dates[0],
      end = _dates[1];
    if (handleDateChange) {
      handleDateChange({
        startDate: moment(dates[0]).format(moment.HTML5_FMT.DATE),
        endDate: dates[1] ? moment(dates[1]).format(moment.HTML5_FMT.DATE) : null
      });
    }
    if (!isExternalCall) {
      setStartDate(start);
      setEndDate(end);
    }
  };
  const handleClose = () => {
    if (!noValidate && (startDate === null || endDate === null)) {
      setError('Select valid date range');
    } else {
      setError(null);
    }
  };
  const keyDownHandler = e => {
    if (e.key !== 'Enter') return;
    const values = e.target.value.split('-');
    if (values && values.length == 2) {
      let newStartDate = Date.parse(values[0]);
      let newEndDate = Date.parse(values[1]);
      if (!isNaN(newStartDate) && !isNaN(newEndDate) && newStartDate <= newEndDate) {
        setStartDate(newStartDate);
        setEndDate(newEndDate);
      }
      onChange([newStartDate, newEndDate], undefined, true);
    }
  };
  return /*#__PURE__*/React.createElement("div", {
    className: classes.rangeDatePicker
  }, /*#__PURE__*/React.createElement(DatePicker, {
    disabled: disabled,
    selected: startDate,
    onKeyDown: keyDownHandler,
    onChange: onChange,
    startDate: startDate,
    endDate: endDate,
    minDate: minDate,
    maxDate: maxDate,
    monthsShown: monthsShown,
    selectsRange: true,
    onCalendarClose: handleClose
    // Left alone by default; a field near the right of its container opens the calendar leftwards.
    ,
    popperPlacement: popperPlacement,
    format: format || 'MM/dd/yy',
    showPreviousMonths: showPreviousMonths,
    customInput: /*#__PURE__*/React.createElement(TextField, {
      label: label || 'Select dates range',
      InputProps: {
        style: {
          paddingRight: '14px'
        },
        endAdornment: /*#__PURE__*/React.createElement(Icon, {
          type: "calendar-picker"
        })
      },
      error: error !== null,
      helperText: error
    })
  }));
}